import React from "react";

const BusinessPayment = () => {
  const cards = [
    {
      name: "Cards",
      content: "Visa, Mastercard, Discover, Diners Club, Verve.",
    },
    {
      name: "Banks",
      content:
        "Zenith bank, First bank, Barclays, Llyods, Nedbank, First national bank, Absa, Standard bank and lots more.",
    },
    {
      name: "Bank Transfer",
      content: "Allows you receive payments via bank transfers.",
    },
    {
      name: "USSD",
      content: "GTB, Zenith bank, First bank, Stanbic IBTC, Access bank.",
    },
    {
      name: "NQR",
      content:
        "A secure QR-code-based payments and collections platform for receiving and making payments",
    },
    {
      name: "Apple Pay",
      content:
        "Allows you recieve payments from your customers with Apple devices.",
    },
    {
      name: "Google Pay",
      content:
        "Allows you recieve payments from your customers via their Google pay digital wallet.",
    },
    {
      name: "eNaira",
      content: "Allows you recieve payments from your customers via eNaira",
    },
    {
      name: "Two factor authentication for login",
      content: "Require two factor authentication everytime you login",
    },
  ];
  return (
    <div className="mt-10">
      {cards.map((c) => {
        return (
          <section className="h-[4.3rem] flex justify-between items-center px-[1.8rem]  border border-gray-200">
            <div className="flex flex-col ">
              <p className="text-[14px] font-[600] text-[#444444]">{c.name}</p>
              <p className="w-[22rem] text-[14px] font-[300] text-[#444444]">
                {c.content}{" "}
              </p>
            </div>
            <div>
              <button className="w-[93px] h-[42px] border border-primary rounded-[7px] text-primary">
                Enable
              </button>
            </div>
          </section>
        );
      })}
    </div>
  );
};

export default BusinessPayment;
